import { FC, useContext, useState } from 'react'

import { EventResultItem } from '../../../../components/EventResultItem'
import { ReportsTabWrapper } from '../ReportsTabWrapper/ReportsTabWrapper'
import { USEFResultsReport } from '../USEFResultsReport/USEFResultsReport'

import { MODAL_CONSTS } from '../../../../../../../const/modal-const'
import { HandleModalContext } from '../../../../../../../layout/mainlayout/MainLayout'
import { TEventRegisteredUsers } from '../../../../../../../models/event-registered-users/event-registered-users.interface'
import { IEventReviewPublish } from '../../../../../../../models/event-review-publish/event-review-publish.interface'
import { IEventInterface } from '../../../../../../../models/events/event.interface'
import { IHorseData } from '../../../../../../../models/horse/horse.interface'
import { IRegistrationByDayInterface } from '../../../../../../../models/registrations-by-day/registrationByDay.interface'
import { IScoreCardInterface } from '../../../../../../../models/score-cards/score-cards.interface'
import { IUserInterface } from '../../../../../../../models/users/user.interface'
import { IReports } from '../../ManageClinicReportsRoot'
import { ExportData } from './customDataExportService'
import { IRiderTeamMemberInterface } from '../../../../../../../models/rider-team-member/riderTeamMember.interface'

interface EventResultsOptions {
  event: IEventInterface | null
  registrationFees: any
  activeOption: IReports
  setActiveOption: (value: IReports) => void
  registeredUsersByDay: IRegistrationByDayInterface[] | null
  horses: IHorseData[] | null
  users: IUserInterface[] | null
  hunterJumperScoreCards: IScoreCardInterface[] | null
  eventReviewPublish: IEventReviewPublish | null
  scheduleBy: 'class' | 'rider'
  eventRegisteredUsers: TEventRegisteredUsers[] | null
  riderTeamMembers: IRiderTeamMemberInterface[]
}
export const EventResultsReport: FC<EventResultsOptions> = ({
  registrationFees,
  setActiveOption,
  activeOption,
  event,
  registeredUsersByDay,
  eventRegisteredUsers,
  horses,
  users,
  hunterJumperScoreCards,
  eventReviewPublish,
  riderTeamMembers,
  scheduleBy,
}) => {
  const [activeResult, setActiveResult] = useState('')

  const handleModalContext = useContext(HandleModalContext)

  const handleCustomDataExport = () => {
    if (handleModalContext) {
      const modalData: ExportData = {
        event,
        registrationFees,
        registeredUsersByDay,
        horses,
        users,
        eventReviewPublish,
        scheduleBy,
        eventRegisteredUsers,
      }

      handleModalContext.handleModal(true, MODAL_CONSTS.CUSTOM_DATA_EXPORT, modalData)
    }
  }

  return activeResult === 'USEF Results' ? (
    <USEFResultsReport
      registrationFees={registrationFees}
      activeOption={activeOption}
      setActiveOption={setActiveOption}
      setActiveResult={setActiveResult}
      event={event}
      registeredUsersByDay={registeredUsersByDay}
      riderTeamMembers={riderTeamMembers}
      horses={horses}
      hunterJumperScoreCards={hunterJumperScoreCards}
    />
  ) : (
    <ReportsTabWrapper
      title="Events Data"
      description="Export event data via spreadsheet"
      activeOption={activeOption}
      setActiveOption={setActiveOption}
    >
      <div className="flex flex-wrap gap-x-[2%] gap-y-5">
        <EventResultItem
          isAvailable
          title="Custom Data Export"
          logo="assets/og_icons/pegasus-color-logo.png"
          onClick={handleCustomDataExport}
        />
        <EventResultItem
          isAvailable
          title="USEF Results"
          logo="assets/images/logos/USEF-logo.png"
          onClick={() => setActiveResult('USEF Results')}
        />
        <EventResultItem
          title="AQHA Results"
          logo="assets/images/logos/AQHA-logo.png"
          onClick={() => {}}
        />
      </div>
    </ReportsTabWrapper>
  )
}
